const SameHeightContainer = () => ({
    sameHeightFor(selector) {
        const elems = this.$el.querySelectorAll(selector);
        const heightMax = this._calculateHeightMax(elems);
        if (!heightMax) return;

        this._applyHeightToElems(elems, heightMax);
    },
    sameHeightForData() {
        const sameHeightElems = this.$el.querySelectorAll('[data-same-height]');
        const dataElems = this._filterDataElems(sameHeightElems);
        const dataKeys = Object.keys(dataElems);

        const apply = () => dataKeys.forEach(dataKey => {
            const heightMax = this._calculateHeightMax(dataElems[dataKey]);
            if (!heightMax) return;
            this._applyHeightToElems(dataElems[dataKey], heightMax);
        });

        window.addEventListener('resize', apply, true);

        apply();
    },
    _filterDataElems(elems) {
        const dataElems = {};

        for (let i = 0; i < elems.length; i++) {
            let elem = elems[i];
            let dataAttrib = elem.dataset.sameHeight;
            if (!dataAttrib) continue;

            if (!dataElems[dataAttrib]) {
                dataElems[dataAttrib] = [];
            }
            dataElems[dataAttrib].push(elem);
        }

        return dataElems;
    },
    _calculateHeightMax(elements) {
        let highest = 0;

        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            if (element.clientHeight > highest) {
                highest = element.clientHeight;
            }
        }

        return highest;
    },
    _applyHeightToElems(elements, height) {
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            element.style.height = height + "px";
        }
    }

});

export default SameHeightContainer;